import { render } from "./Exercise.vue?vue&type=template&id=d6c131f0"
import script from "./Exercise.vue?vue&type=script&lang=js"
export * from "./Exercise.vue?vue&type=script&lang=js"

import "./Exercise.vue?vue&type=style&index=0&id=d6c131f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__